import useOperationLoadedState from '../hooks/use-operation-loaded-state'

export default function WhenNotLoaded (props) {
  const [isLoaded] = useOperationLoadedState()

  return (isLoaded === false) ? props.children : null
}
